// Type for the Playlist that exists within another Playlist

// Properties for Playlist content that's to be rendered in a tree structure
// defined by the sections

export var typeFilterButtons = [{
  labelTranslationKey: 'state_all',
  value: 'all'
}, {
  labelTranslationKey: 'content_type_playlist_plural',
  value: 'playlists'
}, {
  labelTranslationKey: 'content_type_asset_plural',
  value: 'assets'
}];
export var statusFilterButtons = [{
  labelTranslationKey: 'state_all',
  value: 'all'
}, {
  labelTranslationKey: 'state_opened',
  value: 'opened'
}, {
  labelTranslationKey: 'state_completed',
  value: 'completed'
}];